export const container = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      delay: 1.1,
      when: 'beforeChildren',
      staggerChildren: 0.1,
    },
  },
}

export const child = {
  hidden: { y: 30, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      ease: 'easeOut',
      duration: 0.3,
    },
  },
}

export const bgImageContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      delay: 0,
      when: 'beforeChildren',
      staggerChildren: 0.15,
    },
  },
}

export const imageContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      delay: 1.5,
      when: 'beforeChildren',
      staggerChildren: 0.15,
    },
  },
}

export const image = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.3,
    },
  },
}

export const decorationDesktop = {
  hidden: { x: '-50%', opacity: 0 },

  visible: {
    x: 0,
    opacity: 1,
    transition: {
      ease: 'easeOut',
      duration: 0.8,
    },
  },
}

export const decorationMobile = {
  hidden: { y: '40%', opacity: 0 },

  visible: {
    y: 0,
    opacity: 1,
    transition: {
      ease: 'easeOut',
      duration: 0.8,
    },
  },
}
